module.exports = __webpack_public_path__ + "static/media/main4_en_768-min.2a2d7e77.png";